export default defineNuxtRouteMiddleware(async (_to, _from) => {
    const localePath = useLocalePath()
    const { user, refresh } = useAuthUser()

    if (!user.value) {
        await refresh()
    }

    if (user.value) {
        // If the user is logged in, navigate to their company dashboard.
        const companies = await useCompaniesOfUser()
        const slug = companies[0]?.slug
        if (slug) {
            return navigateTo(localePath('/') + slug)
        }
    }
})
